// This file handles authentication logic
// Storing tokens, checking if user is logged in, etc.


/**
 * NOTES-SUMMARY
 * 
 * What this file does:
 *  - Manages JWT tokens
 *  - Stores/retrieves user info
 *  - Checks if user is logged in
 *  - Handles logout

 *Why localStorage?
 *  localStorage is like a mini database in the browser. Data persists even after closing the browser.
 */



// Save JWT token to localStorage
// localStorage persists even after closing browser
export const setToken = (token) => {
  localStorage.setItem('token', token);
};

// Get JWT token from localStorage
export const getToken = () => {
  return localStorage.getItem('token');
};

// Remove JWT token (logout)
export const removeToken = () => {
  localStorage.removeItem('token');
};

// Check if user is logged in
// Returns true if token exists, false if not
export const isAuthenticated = () => {
  return !!getToken(); // !! converts to boolean
};

// Save user info to localStorage
export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

// Get user info from localStorage
export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Remove user info (logout)
export const removeUser = () => {
  localStorage.removeItem('user');
};

// Full logout function
// Removes both token and user info
export const logout = () => {
  removeToken();
  removeUser();
};